import { render } from "./CheckoutShippingOptions.vue?vue&type=template&id=22c9b8e2"
import script from "./CheckoutShippingOptions.vue?vue&type=script&lang=js"
export * from "./CheckoutShippingOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__